/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardRankPoints } from './LeaderboardRankPoints';
import {
    LeaderboardRankPointsFromJSON,
    LeaderboardRankPointsFromJSONTyped,
    LeaderboardRankPointsToJSON,
    LeaderboardRankPointsToJSONTyped,
} from './LeaderboardRankPoints';

/**
 * 
 * @export
 * @interface EarningConfigValues
 */
export interface EarningConfigValues {
    /**
     * Points for following/joining the hub
     * @type {number}
     * @memberof EarningConfigValues
     */
    hubFollow?: number;
    /**
     * Points for winning a challenge
     * @type {number}
     * @memberof EarningConfigValues
     */
    challengeWin?: number;
    /**
     * Points for participating in a challenge (loss)
     * @type {number}
     * @memberof EarningConfigValues
     */
    challengeParticipation?: number;
    /**
     * Points by leaderboard rank range
     * @type {Array<LeaderboardRankPoints>}
     * @memberof EarningConfigValues
     */
    leaderboardRank?: Array<LeaderboardRankPoints>;
    /**
     * Points for completing a sponsor engagement
     * @type {number}
     * @memberof EarningConfigValues
     */
    sponsorEngagement?: number;
    /**
     * Points for completing a playable ad
     * @type {number}
     * @memberof EarningConfigValues
     */
    playableAd?: number;
    /**
     * Points for referring a new member
     * @type {number}
     * @memberof EarningConfigValues
     */
    referral?: number;
    /**
     * Points for daily hub visit (0 to disable)
     * @type {number}
     * @memberof EarningConfigValues
     */
    dailyVisit?: number;
    /**
     * Points for streak milestones
     * @type {number}
     * @memberof EarningConfigValues
     */
    streakMilestone?: number;
    /**
     * Points for quest completion
     * @type {number}
     * @memberof EarningConfigValues
     */
    questCompletion?: number;
    /**
     * Points for watching a hub stream for the minimum threshold duration (default 30 min)
     * @type {number}
     * @memberof EarningConfigValues
     */
    streamWatch?: number;
}

/**
 * Check if a given object implements the EarningConfigValues interface.
 */
export function instanceOfEarningConfigValues(value: object): value is EarningConfigValues {
    return true;
}

export function EarningConfigValuesFromJSON(json: any): EarningConfigValues {
    return EarningConfigValuesFromJSONTyped(json, false);
}

export function EarningConfigValuesFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarningConfigValues {
    if (json == null) {
        return json;
    }
    return {
        
        'hubFollow': json['hubFollow'] == null ? undefined : json['hubFollow'],
        'challengeWin': json['challengeWin'] == null ? undefined : json['challengeWin'],
        'challengeParticipation': json['challengeParticipation'] == null ? undefined : json['challengeParticipation'],
        'leaderboardRank': json['leaderboardRank'] == null ? undefined : ((json['leaderboardRank'] as Array<any>).map(LeaderboardRankPointsFromJSON)),
        'sponsorEngagement': json['sponsorEngagement'] == null ? undefined : json['sponsorEngagement'],
        'playableAd': json['playableAd'] == null ? undefined : json['playableAd'],
        'referral': json['referral'] == null ? undefined : json['referral'],
        'dailyVisit': json['dailyVisit'] == null ? undefined : json['dailyVisit'],
        'streakMilestone': json['streakMilestone'] == null ? undefined : json['streakMilestone'],
        'questCompletion': json['questCompletion'] == null ? undefined : json['questCompletion'],
        'streamWatch': json['streamWatch'] == null ? undefined : json['streamWatch'],
    };
}

export function EarningConfigValuesToJSON(json: any): EarningConfigValues {
    return EarningConfigValuesToJSONTyped(json, false);
}

export function EarningConfigValuesToJSONTyped(value?: EarningConfigValues | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hubFollow': value['hubFollow'],
        'challengeWin': value['challengeWin'],
        'challengeParticipation': value['challengeParticipation'],
        'leaderboardRank': value['leaderboardRank'] == null ? undefined : ((value['leaderboardRank'] as Array<any>).map(LeaderboardRankPointsToJSON)),
        'sponsorEngagement': value['sponsorEngagement'],
        'playableAd': value['playableAd'],
        'referral': value['referral'],
        'dailyVisit': value['dailyVisit'],
        'streakMilestone': value['streakMilestone'],
        'questCompletion': value['questCompletion'],
        'streamWatch': value['streamWatch'],
    };
}

